// Utilities
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";

// Service
import { dailyReportService } from "../../../Api/Services/DailyReportService";

// Constants
import { ERROR_MESSAGES } from "../../../constants/error";
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";

/**
 * Async thunk to download daily report file.
 * Dispatches an API call to download daily report.
 */
export const downloadDailyReportDetailsAsyncThunk = createServiceAsyncThunk<
  { status: string; url: string },
  { filePath: string }
>(
  ACTION_NAMES.DOWNLOAD_DAILY_REPORT, // Action Name
  ({ filePath }) => dailyReportService.downloadDailyReport(filePath), // API Call
  ERROR_MESSAGES.DOWNLOAD_DAILY_REPORT_FAILURE // Error Message
);

/**
 * Slice to manage the state for download daily report.
 * Includes actions to clear errors and handle async states.
 */
export const downloadDailyReportDetailsSlice = createGenericSlice<
  { status: string; url: string },
  { filePath: string }
>(SLICE_NAMES.DOWNLOAD_DAILY_REPORT, downloadDailyReportDetailsAsyncThunk);

// Export the actions to be dispatched in components
export const {
  clearError: clearDownloadDailyReportErrorMessage,
  clearSuccessMessage: clearDownloadDailyReportSuccessMessage,
} = downloadDailyReportDetailsSlice.actions;

// Export the reducer to be used in the store
export default downloadDailyReportDetailsSlice.reducer;
